export default __webpack_public_path__ + "static/media/testResults.245d22e7.svg";